/* ==========================================================================
   Client Brief — çok adımlı B2B brief formu
   --------------------------------------------------------------------------
   Section'daki blokları tek bir state üzerinden yönetir. Soruların ne olduğu
   koda gömülü DEĞİL: her soru kendi tipini, anahtarını ve etiketini DOM'da
   taşır, kontrolcü onları okur. Customizer'dan soru eklemek bu dosyaya
   dokunmadan çalışır — özet ekranı ve n8n'e giden payload da kendiliğinden
   yeni soruyu içerir.

   Sözleşme:
     [data-cb-q][data-cb-type][data-cb-key][data-cb-label]  -> bir soru
     [data-cb-step="0"]                                     -> adım kabı
     [data-cb-screen="welcome|form|thanks"]                 -> ekran
   ========================================================================== */

(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var SAVE_DEBOUNCE = 400;

  /* Widget kurulduktan sonra bu süre boyunca token gelmezse Turnstile
     kullanılamıyor sayılır ve gönderim token'sız geçer; kararı n8n verir. */
  var TS_STALL_MS = 12000;

  /* Turnstile hata kodları. Kod tek başına anlamsız; konsola sebebiyle
     birlikte yazmazsak "doğrulama tamamlanmadı" bir çıkmaz sokak oluyor. */
  var TS_HINTS = {
    '110200': ' -> bu alan adı widget’in Hostnames listesinde YOK (Cloudflare → Turnstile → widget → Settings)',
    '110100': ' -> site key geçersiz; tema ayarındaki anahtar bu widget’e ait mi?',
    '110110': ' -> site key bu alan adı için geçersiz',
    '300010': ' -> Cloudflare tarafında geçici hata, tekrar deneyin',
    '600010': ' -> challenge çözülemedi (genelde otomasyon/başlık engeli)',
    render: ' -> widget hiç kurulamadı',
    noscript: ' -> challenges.cloudflare.com yüklenemedi (reklam engelleyici ya da ağ kısıtı)'
  };

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function fill(tpl, map) {
    var out = String(tpl == null ? '' : tpl);
    Object.keys(map).forEach(function (k) {
      out = out.split(k).join(map[k]);
    });
    return out;
  }

  function formatBytes(n) {
    if (!n && n !== 0) return '';
    if (n < 1024) return n + ' B';
    if (n < 1024 * 1024) return Math.round(n / 1024) + ' KB';
    return (n / (1024 * 1024)).toFixed(1) + ' MB';
  }

  /* ====================================================================== */

  function ClientBrief(root) {
    this.root = root;
    this.sectionId = (root.id || '').replace(/^cb-/, '');

    var cfgEl = $('[data-cb-config]', root);
    this.cfg = {};
    if (cfgEl) {
      try {
        this.cfg = JSON.parse(cfgEl.textContent);
      } catch (e) {
        console.error('[client-brief] config okunamadı', e);
      }
    }

    var all = window.cbStrings || {};
    this.s = all[this.sectionId] || all[Object.keys(all)[0]] || {};

    this.screens = {
      welcome: $('[data-cb-screen="welcome"]', root),
      form: $('[data-cb-screen="form"]', root),
      thanks: $('[data-cb-screen="thanks"]', root)
    };

    this.form = $('[data-cb-form]', root);
    this.steps = $$('[data-cb-step]', root);
    this.top = $('[data-cb-top]', root);
    this.live = $('[data-cb-live]', root);

    this.step = 0;
    this.files = [];
    this.submitting = false;
    this.draftSent = false;
    this.tsToken = '';
    this.tsError = '';
    this.tsMountedAt = 0;
    this.tsRendered = false;
    this._saveTimer = null;

    // Ağ koptuğunda tekrar denense de n8n tarafında tek kayıt açılsın diye
    // sabit kimlik. Taslak ve nihai gönderim aynı kimliği taşır.
    this.requestId = this.newId();

    // :has() desteklemeyen tarayicilarda tam ekran kancasi (bkz. section stili)
    if (this.cfg.fullscreen) document.documentElement.classList.add('cb-fullscreen-on');

    this.bind();
    this.restore();
    this.showScreen(this.restoredStep != null ? 'form' : 'welcome');
    if (this.restoredStep != null) this.goTo(this.restoredStep, true);
  }

  ClientBrief.prototype.newId = function () {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return 'cb-' + Date.now() + '-' + Math.random().toString(36).slice(2);
  };

  /* ------------------------------------------------------------- sorular */

  /** Bir soruyu tanımlayan sözleşmeyi DOM'dan okur. */
  ClientBrief.prototype.meta = function (q) {
    return {
      el: q,
      type: q.getAttribute('data-cb-type'),
      key: q.getAttribute('data-cb-key') || '',
      label: q.getAttribute('data-cb-label') || '',
      required: q.getAttribute('data-cb-required') === 'true',
      step: this.stepOf(q)
    };
  };

  ClientBrief.prototype.stepOf = function (el) {
    var host = el.closest('[data-cb-step]');
    return host ? parseInt(host.getAttribute('data-cb-step'), 10) : -1;
  };

  ClientBrief.prototype.questions = function (stepIndex) {
    var scope = stepIndex == null ? this.root : this.steps[stepIndex];
    if (!scope) return [];
    var self = this;
    return $$('[data-cb-q]', scope).map(function (q) {
      return self.meta(q);
    });
  };

  /** Tek bir sorunun değeri. Tip başına şekli sabittir; payload da bunu kullanır. */
  ClientBrief.prototype.valueOf = function (m) {
    var q = m.el;

    if (m.type === 'field') {
      var input = $('[data-cb-input]', q);
      return input ? input.value.trim() : '';
    }

    if (m.type === 'chips') {
      var multi = q.getAttribute('data-cb-mode') !== 'single';
      var picked = $$('.cb-chip[aria-pressed="true"]', q).map(function (b) {
        return b.getAttribute('data-cb-chip');
      });
      var other = $('[data-cb-other]', q);
      return {
        selected: multi ? picked : picked[0] || '',
        other: other && !other.hidden ? other.value.trim() : ''
      };
    }

    if (m.type === 'sliders') {
      var axes = {};
      $$('.cb-axis', q).forEach(function (ax) {
        var r = $('[data-cb-range]', ax);
        axes[ax.getAttribute('data-cb-axis')] = ax.classList.contains('is-touched')
          ? parseInt(r.value, 10)
          : null;
      });
      return axes;
    }

    if (m.type === 'repeater') {
      return $$('[data-cb-row]', q)
        .map(function (i) {
          return i.value.trim();
        })
        .filter(Boolean);
    }

    if (m.type === 'files') {
      return this.files.map(function (f) {
        return { name: f.name, size: f.size, type: f.type, storageKey: f.storageKey || null };
      });
    }

    if (m.type === 'consent') {
      var c = $('[data-cb-consent]', q);
      return !!(c && c.checked);
    }

    return '';
  };

  /** Değeri insan-okunur tek satıra çevirir (özet ekranı ve mail için). */
  ClientBrief.prototype.displayOf = function (m) {
    var v = this.valueOf(m);
    var none = this.s.none || '—';

    if (m.type === 'field') return v || none;

    if (m.type === 'chips') {
      var list = Array.isArray(v.selected) ? v.selected : v.selected ? [v.selected] : [];
      var txt = list.join(', ');
      if (v.other) txt = txt ? txt + ' (' + v.other + ')' : v.other;
      return txt || none;
    }

    if (m.type === 'sliders') {
      var parts = [];
      $$('.cb-axis', m.el).forEach(function (ax) {
        var val = v[ax.getAttribute('data-cb-axis')];
        if (val == null) return;
        parts.push(ax.getAttribute('data-cb-left') + '/' + ax.getAttribute('data-cb-right') + ': ' + val);
      });
      return parts.length ? parts.join(' · ') : none;
    }

    if (m.type === 'repeater') return v.length ? v.join(' | ') : none;

    if (m.type === 'files') {
      return v.length
        ? v
            .map(function (f) {
              return f.name;
            })
            .join(', ')
        : none;
    }

    if (m.type === 'consent') return '';

    return none;
  };

  /* ---------------------------------------------------------- doğrulama */

  ClientBrief.prototype.setError = function (m, msg) {
    var box = $('[data-cb-err]', m.el);
    if (msg) {
      m.el.classList.add('is-invalid');
      if (box) {
        box.textContent = msg;
        box.hidden = false;
      }
    } else {
      m.el.classList.remove('is-invalid');
      if (box) {
        box.textContent = '';
        box.hidden = true;
      }
    }
  };

  ClientBrief.prototype.validateQuestion = function (m) {
    var v = this.valueOf(m);
    var s = this.s;

    if (m.type === 'field') {
      var input = $('[data-cb-input]', m.el);
      var kind = input ? input.getAttribute('type') : 'text';
      if (m.required && !v) return s.errRequired;
      if (v && kind === 'email' && !EMAIL_RE.test(v)) return s.errEmail;
      if (v && kind === 'url' && !/^https?:\/\/.+/i.test(v)) return s.errUrl;
      return '';
    }

    if (m.type === 'chips') {
      var list = Array.isArray(v.selected) ? v.selected : v.selected ? [v.selected] : [];
      if (m.required && !list.length) return s.errRequired;
      // "Diğer" seçiliyse serbest metin boş kalmamalı, yoksa cevap bilgi taşımaz.
      var otherOn = $$('.cb-chip[aria-pressed="true"]', m.el).some(function (b) {
        return b.getAttribute('data-cb-chip-role') === 'other' || b.dataset.cbAutoOther === '1';
      });
      if (otherOn && !v.other) return s.errRequired;
      return '';
    }

    if (m.type === 'repeater') {
      if (m.required && !v.length) return s.errRequired;
      return '';
    }

    if (m.type === 'consent') {
      if (m.required && !v) return s.errConsent;
      return '';
    }

    return '';
  };

  ClientBrief.prototype.validateStep = function (i) {
    var self = this;
    var ok = true;
    var firstBad = null;

    this.questions(i).forEach(function (m) {
      var msg = self.validateQuestion(m);
      self.setError(m, msg);
      if (msg && ok) {
        ok = false;
        firstBad = m;
      }
    });

    if (firstBad) {
      var focusable = $('input, textarea, button', firstBad.el);
      if (focusable) focusable.focus();
      firstBad.el.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    return ok;
  };

  /* -------------------------------------------------------------- gezinme */

  ClientBrief.prototype.showScreen = function (name) {
    var self = this;
    Object.keys(this.screens).forEach(function (k) {
      if (self.screens[k]) self.screens[k].hidden = k !== name;
    });
    if (this.top) this.top.hidden = name !== 'form';
  };

  ClientBrief.prototype.isLast = function (i) {
    return i === this.steps.length - 1;
  };

  ClientBrief.prototype.goTo = function (i, silent) {
    if (i < 0 || i >= this.steps.length) return;

    this.step = i;
    this.steps.forEach(function (el, idx) {
      el.hidden = idx !== i;
    });

    if (this.isLast(i)) this.renderReview();
    this.syncChrome();
    this.save();

    if (!silent) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      var h = $('.cb-step__title', this.steps[i]);
      if (h) h.focus({ preventScroll: true });
      if (this.live) {
        this.live.textContent = fill(this.s.stepOf || '[c]/[t]', {
          '[c]': i + 1,
          '[t]': this.steps.length
        });
      }
    }

    if (this.isLast(i)) this.mountTurnstile();
  };

  ClientBrief.prototype.next = function () {
    if (!this.validateStep(this.step)) return;

    if (this.step === 0) this.sendDraft();

    if (this.isLast(this.step)) {
      this.submit();
      return;
    }
    this.goTo(this.step + 1);
  };

  ClientBrief.prototype.back = function () {
    if (this.step === 0) {
      this.showScreen('welcome');
      return;
    }
    this.goTo(this.step - 1);
  };

  /** Üst çubuk, ilerleme ve buton etiketleri tek yerden güncellenir. */
  ClientBrief.prototype.syncChrome = function () {
    var i = this.step;
    var total = this.steps.length;
    var el = this.steps[i];
    if (!el) return;

    var counter = fill(this.s.stepOf || '[c]/[t]', { '[c]': i + 1, '[t]': total });
    var code = el.getAttribute('data-cb-code') || '';
    var eyebrow = el.getAttribute('data-cb-eyebrow') || '';

    var setText = function (sel, txt) {
      var n = $(sel, this.root);
      if (n) n.textContent = txt;
    }.bind(this);

    setText('[data-cb-top-count]', counter);
    setText('[data-cb-bottom-count]', counter);
    setText('[data-cb-top-code]', code ? fill(this.s.sectionCode || 'Section—[c]', { '[c]': code }) : '');
    setText('[data-cb-top-eyebrow]', eyebrow ? '↳ ' + eyebrow : '');

    var pct = Math.round(((i + 1) / total) * 100);
    var bar = $('[data-cb-progress-bar]', this.root);
    if (bar) bar.style.width = pct + '%';
    var prog = $('[data-cb-progress]', this.root);
    if (prog) prog.setAttribute('aria-valuenow', String(pct));

    var nextLbl = $('[data-cb-next-label]', this.root);
    if (nextLbl) nextLbl.textContent = this.isLast(i) ? this.s.submit || 'Gönder' : this.s.next || 'Devam';

    var backBtn = $('[data-cb-back]', this.root);
    if (backBtn) backBtn.disabled = false;
  };

  /* ---------------------------------------------------------------- özet */

  ClientBrief.prototype.renderReview = function () {
    var host = $('[data-cb-review]', this.root);
    if (!host) return;
    var self = this;

    host.textContent = '';

    this.steps.forEach(function (stepEl, idx) {
      if (self.isLast(idx)) return; // özet adımının kendisi listelenmez

      var qs = self.questions(idx).filter(function (m) {
        return m.type !== 'consent';
      });
      if (!qs.length) return;

      var group = document.createElement('div');
      group.className = 'cb-review__group';

      var head = document.createElement('div');
      head.className = 'cb-review__head';

      var title = document.createElement('span');
      title.className = 'cb-review__title';
      var code = stepEl.getAttribute('data-cb-code');
      var eyebrow = stepEl.getAttribute('data-cb-eyebrow') || '';
      title.textContent = code ? code + ' — ' + eyebrow : eyebrow;

      var edit = document.createElement('button');
      edit.type = 'button';
      edit.className = 'cb-review__edit';
      edit.textContent = self.s.edit || 'Düzenle';
      edit.addEventListener('click', function () {
        self.goTo(idx);
      });

      head.appendChild(title);
      head.appendChild(edit);
      group.appendChild(head);

      var dl = document.createElement('dl');
      dl.style.margin = '0';

      qs.forEach(function (m) {
        var text = self.displayOf(m);
        var row = document.createElement('div');
        row.className = 'cb-review__line';
        if (text === (self.s.none || '—')) row.className += ' cb-review__line--empty';

        var dt = document.createElement('dt');
        dt.textContent = m.label;
        var dd = document.createElement('dd');
        dd.textContent = text; // kullanıcı metni her zaman textContent ile basılıyor

        row.appendChild(dt);
        row.appendChild(dd);
        dl.appendChild(row);
      });

      group.appendChild(dl);
      host.appendChild(group);
    });
  };

  /* --------------------------------------------------------------- dosya */

  ClientBrief.prototype.filesQuestion = function () {
    var q = $('[data-cb-type="files"]', this.root);
    return q ? this.meta(q) : null;
  };

  ClientBrief.prototype.addFiles = function (list) {
    var m = this.filesQuestion();
    if (!m) return;

    var maxFiles = parseInt(m.el.getAttribute('data-cb-max-files'), 10) || 5;
    var maxMb = parseInt(m.el.getAttribute('data-cb-max-mb'), 10) || 100;
    var accept = (m.el.getAttribute('data-cb-accept') || '')
      .split(',')
      .map(function (x) {
        return x.trim().toLowerCase();
      })
      .filter(Boolean);

    var self = this;
    var err = '';

    Array.prototype.slice.call(list).forEach(function (f) {
      if (self.files.length >= maxFiles) {
        err = fill(self.s.errFileCount || '', { '[n]': maxFiles });
        return;
      }
      if (f.size > maxMb * 1024 * 1024) {
        err = fill(self.s.errFileSize || '', { '[name]': f.name, '[mb]': maxMb });
        return;
      }
      if (accept.length) {
        var dot = f.name.lastIndexOf('.');
        var ext = dot > -1 ? f.name.slice(dot).toLowerCase() : '';
        if (accept.indexOf(ext) === -1) {
          err = fill(self.s.errFileType || '', { '[name]': f.name });
          return;
        }
      }
      self.files.push({ file: f, name: f.name, size: f.size, type: f.type || 'application/octet-stream' });
    });

    this.setError(m, err);
    this.renderFiles();
  };

  ClientBrief.prototype.renderFiles = function () {
    var m = this.filesQuestion();
    if (!m) return;
    var host = $('[data-cb-file-list]', m.el);
    if (!host) return;
    var self = this;

    host.textContent = '';

    this.files.forEach(function (f, idx) {
      var li = document.createElement('li');
      li.className = 'cb-file' + (f.error ? ' is-error' : '');

      var name = document.createElement('span');
      name.className = 'cb-file__name';
      name.textContent = f.name;

      var meta = document.createElement('span');
      meta.className = 'cb-file__meta';

      var size = document.createElement('span');
      size.textContent = f.status || formatBytes(f.size);
      meta.appendChild(size);

      var rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'cb-file__remove';
      rm.textContent = self.s.remove || 'Kaldır';
      rm.addEventListener('click', function () {
        self.files.splice(idx, 1);
        self.renderFiles();
      });
      meta.appendChild(rm);

      li.appendChild(name);
      li.appendChild(meta);
      host.appendChild(li);
    });

    // Yükleme ucu yoksa müşteri dosyayı bıraktığını sanmasın.
    var hint = $('.cb-drop__hint', m.el);
    if (hint && !this.cfg.uploadWebhook && this.files.length) {
      hint.textContent = this.s.noUpload || hint.textContent;
    }
  };

  /**
   * Dosyalar n8n'den alınan presigned PUT adresleriyle doğrudan S3'e gider.
   * Böylece 100 MB'lık bir marka kılavuzu n8n'in gövdesinden geçmez.
   */
  ClientBrief.prototype.uploadFiles = function () {
    var self = this;
    if (!this.files.length) return Promise.resolve();
    if (!this.cfg.uploadWebhook) return Promise.resolve(); // uç yoksa sadece dosya adları gider

    var manifest = this.files.map(function (f) {
      return { name: f.name, size: f.size, type: f.type };
    });

    this.files.forEach(function (f) {
      f.status = self.s.uploading || '…';
    });
    this.renderFiles();

    return fetch(this.cfg.uploadWebhook, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ clientRequestId: this.requestId, files: manifest })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var uploads = (data && data.uploads) || [];
        return Promise.all(
          uploads.map(function (u, i) {
            var f = self.files[i];
            if (!f || !u.url) return null;
            return fetch(u.url, {
              method: 'PUT',
              headers: u.headers || { 'Content-Type': f.type },
              body: f.file
            }).then(function (r) {
              if (!r.ok) throw new Error('S3 ' + r.status);
              f.storageKey = u.key || null;
              f.status = self.s.uploaded || '✓';
              self.renderFiles();
            });
          })
        );
      });
  };

  /* ------------------------------------------------------------ turnstile */

  ClientBrief.prototype.mountTurnstile = function () {
    var slot = $('[data-cb-turnstile-slot]', this.root);
    if (!slot || this.tsRendered || !this.cfg.turnstile) return;

    slot.hidden = false;
    var self = this;
    var target = $('[data-cb-turnstile]', slot) || slot;

    var render = function () {
      if (self.tsRendered) return;
      self.tsRendered = true;
      self.tsMountedAt = Date.now();
      try {
        window.turnstile.render(target, {
          sitekey: self.cfg.turnstile,
          theme: 'light',
          // Widget'in dili sayfayla aynı olsun; boş bırakılırsa tarayıcı dili
          // kullanılır ve Türkçe sayfada İngilizce kutu çıkabiliyor.
          language: self.cfg.locale || 'auto',
          callback: function (token) {
            self.tsToken = token;
            self.tsError = '';
          },
          'expired-callback': function () {
            self.tsToken = '';
          },
          /* Hata kodunu yakalamazsak kullanıcı da biz de yalnızca "doğrulama
             tamamlanmadı" görürüz ve sebebi hiç öğrenilemez. */
          'error-callback': function (code) {
            self.tsToken = '';
            self.tsError = String(code || '');
            console.error(
              '[client-brief] Turnstile hatası: ' + self.tsError + (TS_HINTS[self.tsError] || '')
            );
            return true; // widget kendi hata durumunu göstersin
          }
        });
      } catch (e) {
        // Render patlarsa bayrağı geri al ki sonraki denemede tekrar kurulsun.
        self.tsRendered = false;
        self.tsMountedAt = 0;
        self.tsError = 'render';
        console.error('[client-brief] Turnstile render edilemedi', e);
      }
    };

    // Script async yükleniyor; hazır değilse kısa aralıklarla bekliyoruz.
    if (window.turnstile && window.turnstile.render) {
      render();
    } else {
      var tries = 0;
      var timer = setInterval(function () {
        if (window.turnstile && window.turnstile.render) {
          clearInterval(timer);
          render();
        } else if (++tries > 24) {
          clearInterval(timer);
          self.tsError = 'noscript';
          console.error('[client-brief] Turnstile hatası: noscript' + TS_HINTS.noscript);
        }
      }, 250);
    }
  };

  ClientBrief.prototype.turnstileToken = function () {
    if (this.tsToken) return this.tsToken;
    var input = this.form && this.form.querySelector('[name="cf-turnstile-response"]');
    return input ? input.value : '';
  };

  /* ------------------------------------------------------------- payload */

  ClientBrief.prototype.buildPayload = function (event) {
    var self = this;
    var answers = {};
    var labels = {};
    var types = {};
    var stepList = [];

    this.steps.forEach(function (stepEl, idx) {
      var keys = [];
      self.questions(idx).forEach(function (m) {
        if (!m.key) return;
        var v = self.valueOf(m);

        if (m.type === 'chips') {
          answers[m.key] = v.selected;
          if (v.other) answers[m.key + '_other'] = v.other;
        } else if (m.type === 'sliders') {
          answers[m.key] = v;
        } else {
          answers[m.key] = v;
        }

        labels[m.key] = m.label;
        types[m.key] = m.type;
        keys.push(m.key);
      });

      stepList.push({
        index: idx,
        code: stepEl.getAttribute('data-cb-code') || '',
        title: stepEl.getAttribute('data-cb-eyebrow') || '',
        keys: keys
      });
    });

    var hp = $('[name="cb_website"]', this.root);

    return {
      event: event || 'submit',
      clientRequestId: this.requestId,
      locale: this.cfg.locale || '',
      pageHandle: this.cfg.pageHandle || '',
      submittedAt: new Date().toISOString(),
      pageUrl: window.location.href,
      referrer: document.referrer || '',
      // Şema n8n'e birlikte gidiyor: mail gövdesi ve panel, sorular değişince
      // kendiliğinden güncellenir; iki yerde bakım gerekmez.
      schema: { labels: labels, types: types, steps: stepList },
      answers: answers,
      files: this.files.map(function (f) {
        return { name: f.name, size: f.size, type: f.type, storageKey: f.storageKey || null };
      }),
      summaryText: this.buildSummaryText(),
      honeypot: hp ? hp.value : '',
      'cf-turnstile-response': this.turnstileToken()
    };
  };

  /** Müşterinin özet ekranında gördüğü metnin birebir aynısı — mail gövdesi. */
  ClientBrief.prototype.buildSummaryText = function () {
    var self = this;
    var out = [];

    this.steps.forEach(function (stepEl, idx) {
      if (self.isLast(idx)) return;
      var qs = self.questions(idx).filter(function (m) {
        return m.type !== 'consent';
      });
      if (!qs.length) return;

      var code = stepEl.getAttribute('data-cb-code');
      var eyebrow = stepEl.getAttribute('data-cb-eyebrow') || '';
      out.push(code ? code + ' — ' + eyebrow : eyebrow);
      qs.forEach(function (m) {
        out.push(m.label + ': ' + self.displayOf(m));
      });
      out.push('');
    });

    return out.join('\n').trim();
  };

  /* ----------------------------------------------------------- gönderim */

  ClientBrief.prototype.formError = function (msg) {
    var box = $('[data-cb-form-error]', this.root);
    if (!box) return;
    if (msg) {
      box.textContent = msg;
      box.hidden = false;
      box.scrollIntoView({ block: 'center', behavior: 'smooth' });
    } else {
      box.textContent = '';
      box.hidden = true;
    }
  };

  /**
   * İletişim adımı geçilir geçilmez taslak atılır. Müşteri formu yarıda
   * bıraksa bile satış ekibinin elinde ad + e-posta kalır. Nihai gönderim
   * aynı clientRequestId ile geldiği için n8n tarafında upsert olur.
   */
  ClientBrief.prototype.sendDraft = function () {
    if (this.draftSent || !this.cfg.captureDraft || !this.cfg.submitWebhook) return;

    var payload = this.buildPayload('draft');
    var email = '';
    Object.keys(payload.answers).forEach(function (k) {
      var v = payload.answers[k];
      if (typeof v === 'string' && EMAIL_RE.test(v)) email = v;
    });
    if (!email) return; // e-posta yoksa takip edilecek bir şey de yok

    this.draftSent = true;
    var body = JSON.stringify(payload);
    fetch(this.cfg.submitWebhook, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body,
      // keepalive govdesi 64 KB ile sinirli; asilirsa istek sessizce dusuyor.
      keepalive: body.length < 60000
    })['catch'](function (err) {
      // Taslak en iyi çaba: başarısız olursa müşteriye hiçbir şey gösterilmez.
      console.warn('[client-brief] taslak gönderilemedi', err);
    });
  };

  ClientBrief.prototype.submit = function () {
    var self = this;
    if (this.submitting) return;

    this.formError('');

    if (!this.cfg.submitWebhook) {
      this.formError(this.s.errNoWebhook || 'Gönderim ucu tanımlı değil.');
      console.error('[client-brief] settings.brief_submit_webhook boş');
      return;
    }

    var hp = $('[name="cb_website"]', this.root);
    if (hp && hp.value) {
      // Bot. Sessizce başarı ekranına düşürüyoruz ki "başarısız" sinyali almasın.
      this.finish(null);
      return;
    }

    if (this.cfg.turnstile && !this.turnstileToken()) {
      /* Widget HİÇ kurulamadıysa kullanıcıyı burada tutmuyoruz: token'sız
         gönderip kararı n8n'e bırakıyoruz (brief_config.require_turnstile).
         Aksi hâlde kurumsal bir güvenlik eklentisi ya da ağ kısıtı
         challenges.cloudflare.com'u engellediğinde o müşteriden brief HİÇ
         gelmez — ve kimse sebebini öğrenemez. Bot koruması, gelmeyen
         brief'ten daha az önemli.

         Widget kurulduysa ama kullanıcı henüz tamamlamadıysa engellemeye
         devam ediyoruz; orada "biraz bekleyin" gerçekten doğru cevap. */
      /* Widget kurulduğu hâlde uzun süredir token üretmiyorsa da vazgeçiyoruz.
         Managed modda normal bir kullanıcı etkileşimsiz olarak birkaç saniyede
         token alır; challenge iframe'i engellenmişse (api.js geçer ama
         cdn-cgi/challenge-platform engellenir) widget görünmez, hata da
         fırlatmaz — sonsuza kadar "biraz bekleyin" demek olurdu. */
      var stalled = this.tsMountedAt && Date.now() - this.tsMountedAt > TS_STALL_MS;
      var unavailable = this.tsError === 'noscript' || this.tsError === 'render' || stalled;
      if (!unavailable) {
        var tsMsg = this.s.errTurnstile || 'Güvenlik doğrulaması tamamlanmadı.';
        // Kodu mesaja iliştiriyoruz: kullanıcı konsol açmadan sebebi iletebilsin.
        if (this.tsError) tsMsg += ' (' + this.tsError + ')';
        this.formError(tsMsg);
        return;
      }
      console.warn(
        '[client-brief] Turnstile kullanılamıyor (' + this.tsError + '), token olmadan gönderiliyor'
      );
    }

    this.submitting = true;
    var btn = $('[data-cb-next]', this.root);
    var lbl = $('[data-cb-next-label]', this.root);
    if (btn) btn.disabled = true;
    if (lbl) lbl.textContent = this.s.sending || '…';

    this.uploadFiles()
      .then(function () {
        return fetch(self.cfg.submitWebhook, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(self.buildPayload('submit'))
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json()['catch'](function () {
          return {};
        });
      })
      .then(function (data) {
        self.finish(data);
      })['catch'](function (err) {
        console.error('[client-brief] gönderilemedi', err);
        self.formError(
          err && String(err.message).indexOf('S3') === 0
            ? self.s.errUpload || self.s.errSubmit
            : self.s.errSubmit || 'Gönderilemedi.'
        );
        // Turnstile token'ı tek kullanımlık; sıfırlamazsak ikinci deneme takılır.
        if (window.turnstile && window.turnstile.reset) {
          try {
            window.turnstile.reset();
          } catch (e) {
            /* widget yoksa önemsiz */
          }
        }
        self.tsToken = '';
      })
      .then(function () {
        self.submitting = false;
        if (btn) btn.disabled = false;
        if (lbl) lbl.textContent = self.s.submit || 'Gönder';
      });
  };

  ClientBrief.prototype.finish = function (data) {
    this.clearSaved();
    this.fillThanks(data);
    this.showScreen('thanks');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  ClientBrief.prototype.fillThanks = function (data) {
    var body = $('[data-cb-thanks-body]', this.root);
    var email = '';

    this.questions().forEach(function (m) {
      if (m.type !== 'field') return;
      var input = $('[data-cb-input]', m.el);
      if (input && input.getAttribute('type') === 'email' && input.value.trim()) {
        email = input.value.trim();
      }
    });

    // {email} yer tutucusu metin düğümlerinde değiştiriliyor; kullanıcı girdisi
    // hiçbir zaman innerHTML'e yazılmıyor.
    if (body && email) {
      var walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, null);
      var hits = [];
      while (walker.nextNode()) {
        if (walker.currentNode.nodeValue.indexOf('{email}') > -1) hits.push(walker.currentNode);
      }
      hits.forEach(function (node) {
        var parts = node.nodeValue.split('{email}');
        var frag = document.createDocumentFragment();
        parts.forEach(function (p, i) {
          frag.appendChild(document.createTextNode(p));
          if (i < parts.length - 1) {
            var strong = document.createElement('strong');
            strong.textContent = email;
            frag.appendChild(strong);
          }
        });
        node.parentNode.replaceChild(frag, node);
      });
    }

    var ref = $('[data-cb-ref]', this.root);
    if (ref && data && data.referenceNo) {
      ref.textContent = '';
      var strong = document.createElement('strong');
      strong.textContent = data.referenceNo;
      ref.appendChild(strong);
      ref.hidden = false;
    }
  };

  ClientBrief.prototype.restart = function () {
    var self = this;
    this.clearSaved();
    this.files = [];
    this.draftSent = false;
    this.requestId = this.newId();
    if (this.form) this.form.reset();
    $$('.cb-chip', this.root).forEach(function (b) {
      b.setAttribute('aria-pressed', 'false');
      b.removeAttribute('aria-disabled');
    });
    $$('[data-cb-other]', this.root).forEach(function (i) {
      i.hidden = true;
      i.value = '';
    });
    $$('.cb-axis', this.root).forEach(function (ax) {
      ax.classList.remove('is-touched');
      var r = $('[data-cb-range]', ax);
      if (r) r.value = 50;
    });
    this.renderFiles();
    this.questions().forEach(function (m) {
      self.setError(m, '');
    });
    this.step = 0;
    this.showScreen('welcome');
  };

  /* --------------------------------------------------------- taslak saklama */

  ClientBrief.prototype.storageKey = function () {
    return this.cfg.storageKey || 'cb:brief';
  };

  ClientBrief.prototype.save = function () {
    if (!this.cfg.saveLocal) return;
    var self = this;
    clearTimeout(this._saveTimer);
    this._saveTimer = setTimeout(function () {
      var answers = {};
      self.questions().forEach(function (m) {
        if (m.key) answers[m.key] = self.valueOf(m);
      });
      try {
        localStorage.setItem(
          self.storageKey(),
          JSON.stringify({ step: self.step, answers: answers, requestId: self.requestId })
        );
      } catch (e) {
        /* özel pencere / kota dolu — taslak saklama sessizce devre dışı */
      }
    }, SAVE_DEBOUNCE);
  };

  ClientBrief.prototype.clearSaved = function () {
    try {
      localStorage.removeItem(this.storageKey());
    } catch (e) {
      /* önemsiz */
    }
  };

  ClientBrief.prototype.restore = function () {
    if (!this.cfg.saveLocal) return;
    var raw;
    try {
      raw = localStorage.getItem(this.storageKey());
    } catch (e) {
      return;
    }
    if (!raw) return;

    var data;
    try {
      data = JSON.parse(raw);
    } catch (e) {
      return;
    }
    if (!data || !data.answers) return;

    if (data.requestId) this.requestId = data.requestId;
    var self = this;

    this.questions().forEach(function (m) {
      var v = data.answers[m.key];
      if (v === undefined) return;

      if (m.type === 'field') {
        var input = $('[data-cb-input]', m.el);
        if (input) input.value = v || '';
      } else if (m.type === 'chips') {
        var list = Array.isArray(v.selected) ? v.selected : v.selected ? [v.selected] : [];
        $$('.cb-chip', m.el).forEach(function (b) {
          b.setAttribute('aria-pressed', list.indexOf(b.getAttribute('data-cb-chip')) > -1 ? 'true' : 'false');
        });
        var other = $('[data-cb-other]', m.el);
        if (other && v.other) {
          other.hidden = false;
          other.value = v.other;
        }
        self.syncChipLimit(m.el);
      } else if (m.type === 'sliders') {
        $$('.cb-axis', m.el).forEach(function (ax) {
          var val = v[ax.getAttribute('data-cb-axis')];
          if (val == null) return;
          var r = $('[data-cb-range]', ax);
          if (r) r.value = val;
          ax.classList.add('is-touched');
        });
      } else if (m.type === 'repeater') {
        $$('[data-cb-row]', m.el).forEach(function (input, i) {
          if (v[i]) input.value = v[i];
        });
      } else if (m.type === 'consent') {
        var c = $('[data-cb-consent]', m.el);
        if (c) c.checked = !!v;
      }
    });

    if (typeof data.step === 'number' && data.step >= 0 && data.step < this.steps.length) {
      this.restoredStep = data.step;
    }
  };

  /* ------------------------------------------------------------- bağlama */

  /** Çoklu seçimde tavana ulaşıldıysa seçilmemiş chip'ler pasifleşir. */
  ClientBrief.prototype.syncChipLimit = function (qEl) {
    var max = parseInt(qEl.getAttribute('data-cb-max'), 10) || 0;
    if (!max || qEl.getAttribute('data-cb-mode') === 'single') return;
    var chosen = $$('.cb-chip[aria-pressed="true"]', qEl).length;
    $$('.cb-chip', qEl).forEach(function (b) {
      if (b.getAttribute('aria-pressed') === 'true') {
        b.removeAttribute('aria-disabled');
      } else if (chosen >= max) {
        b.setAttribute('aria-disabled', 'true');
      } else {
        b.removeAttribute('aria-disabled');
      }
    });
  };

  ClientBrief.prototype.isOtherChip = function (btn) {
    if (btn.getAttribute('data-cb-chip-role') === 'other') return true;
    var words = (this.s.otherWords || 'diğer,diger,other')
      .toLowerCase()
      .split(',')
      .map(function (w) {
        return w.trim();
      });
    var label = (btn.getAttribute('data-cb-chip') || '').toLowerCase().trim();
    var hit = words.indexOf(label) > -1;
    if (hit) btn.dataset.cbAutoOther = '1';
    return hit;
  };

  ClientBrief.prototype.toggleChip = function (btn) {
    var qEl = btn.closest('[data-cb-q]');
    if (!qEl || btn.getAttribute('aria-disabled') === 'true') return;

    var single = qEl.getAttribute('data-cb-mode') === 'single';
    var on = btn.getAttribute('aria-pressed') === 'true';

    if (single) {
      $$('.cb-chip', qEl).forEach(function (b) {
        b.setAttribute('aria-pressed', 'false');
      });
      btn.setAttribute('aria-pressed', on ? 'false' : 'true');
    } else {
      btn.setAttribute('aria-pressed', on ? 'false' : 'true');
    }

    this.syncChipLimit(qEl);

    // "Diğer" seçiliyken serbest metin kutusu açılır, bırakılınca temizlenir.
    var other = $('[data-cb-other]', qEl);
    if (other) {
      var self = this;
      var anyOther = $$('.cb-chip[aria-pressed="true"]', qEl).some(function (b) {
        return self.isOtherChip(b);
      });
      other.hidden = !anyOther;
      if (!anyOther) other.value = '';
      else other.focus();
    }

    this.setError(this.meta(qEl), '');
    this.save();
  };

  ClientBrief.prototype.bind = function () {
    var self = this;
    var root = this.root;

    // Hangi chip'in "Diğer" olduğunu bir kez işaretle (locale kelimeleriyle).
    $$('.cb-chip', root).forEach(function (b) {
      self.isOtherChip(b);
    });

    var startBtn = $('[data-cb-start]', root);
    if (startBtn) {
      startBtn.addEventListener('click', function () {
        self.showScreen('form');
        self.goTo(self.step || 0);
      });
    }

    var restartBtn = $('[data-cb-restart]', root);
    if (restartBtn) {
      restartBtn.addEventListener('click', function () {
        self.restart();
      });
    }

    var backBtn = $('[data-cb-back]', root);
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        self.back();
      });
    }

    if (this.form) {
      this.form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        self.next();
      });

      // Tek satır alanlarda Enter bir sonraki adıma geçirir; textarea'da geçmez.
      this.form.addEventListener('keydown', function (ev) {
        if (ev.key !== 'Enter') return;
        var t = ev.target;
        if (t.tagName === 'TEXTAREA') return;
        if (t.tagName === 'BUTTON') return;
        if (t.tagName === 'INPUT') {
          ev.preventDefault();
          self.next();
        }
      });
    }

    root.addEventListener('click', function (ev) {
      var chip = ev.target.closest('.cb-chip');
      if (chip) {
        ev.preventDefault();
        self.toggleChip(chip);
        return;
      }

      var drop = ev.target.closest('[data-cb-drop]');
      if (drop) {
        ev.preventDefault();
        var input = $('[data-cb-file-input]', drop.closest('[data-cb-q]'));
        if (input) input.click();
      }
    });

    root.addEventListener('keydown', function (ev) {
      var drop = ev.target.closest('[data-cb-drop]');
      if (drop && (ev.key === 'Enter' || ev.key === ' ')) {
        ev.preventDefault();
        var input = $('[data-cb-file-input]', drop.closest('[data-cb-q]'));
        if (input) input.click();
      }
    });

    root.addEventListener('change', function (ev) {
      var fileInput = ev.target.closest('[data-cb-file-input]');
      if (fileInput) {
        self.addFiles(fileInput.files);
        fileInput.value = '';
        return;
      }

      var range = ev.target.closest('[data-cb-range]');
      if (range) {
        range.closest('.cb-axis').classList.add('is-touched');
      }

      self.save();
    });

    root.addEventListener('input', function (ev) {
      var range = ev.target.closest('[data-cb-range]');
      if (range) range.closest('.cb-axis').classList.add('is-touched');

      var q = ev.target.closest('[data-cb-q]');
      if (q && q.classList.contains('is-invalid')) self.setError(self.meta(q), '');

      self.save();
    });

    // Sürükle-bırak
    var dropzones = $$('[data-cb-drop]', root);
    dropzones.forEach(function (dz) {
      ['dragenter', 'dragover'].forEach(function (evt) {
        dz.addEventListener(evt, function (e) {
          e.preventDefault();
          dz.classList.add('is-over');
        });
      });
      ['dragleave', 'drop'].forEach(function (evt) {
        dz.addEventListener(evt, function (e) {
          e.preventDefault();
          dz.classList.remove('is-over');
        });
      });
      dz.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files) self.addFiles(e.dataTransfer.files);
      });
    });
  };

  /* ---------------------------------------------------------------- açılış */

  function init() {
    $$('[data-brief]').forEach(function (root) {
      if (root.dataset.cbReady === '1') return;
      root.dataset.cbReady = '1';
      new ClientBrief(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Customizer'da section yeniden yüklendiğinde tekrar bağlan.
  document.addEventListener('shopify:section:load', function (ev) {
    var root = ev.target.querySelector('[data-brief]');
    if (root) {
      root.dataset.cbReady = '';
      init();
    }
  });
})();
